import { render, staticRenderFns } from "./KNavbarLink.vue?vue&type=template&id=0ba96d1a&scoped=true&"
import script from "./KNavbarLink.vue?vue&type=script&lang=js&"
export * from "./KNavbarLink.vue?vue&type=script&lang=js&"
import style0 from "./KNavbarLink.vue?vue&type=style&index=0&id=0ba96d1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba96d1a",
  null
  
)

export default component.exports